import {lazy} from 'react';


import * as staticConstants from './staticConstants';

import StaticPages from './pages';

const InfoMoodWall = lazy(() => import('./components/InfoMoodWall'));


export {
    InfoMoodWall,
    StaticPages,
    staticConstants
};
